import type { CartItemInput } from '~/interfaces/CartItemInput'
import { CartStore } from '~/services/api/contracts/requests/CartStore'
import { hasText } from '~/utils/hasText'
import { Normalization } from '~/utils/normalization'
import { transformCustomizationsToApi } from '~/utils/transformCustomizationsToApi'

/** The validated add-to-cart request body for an item, store and optional requested date and time. */
export function buildAddItemPayload(
  item: CartItemInput,
  storeSlug: string,
  requestedDate: string | null,
  requestedTime: string | null
) {
  return CartStore({}).parse({
    menu_item_id: item.menuItem.id,
    quantity: item.quantity ?? 1,
    special_instructions: item.special_instructions ?? '',
    customizations: transformCustomizationsToApi(item.customizations),
    serves_count: String(Normalization.intValue(item.menuItem.serves_count, 1) ?? 1),
    store_slug: storeSlug,
    ...(hasText(requestedDate) ? { requested_date: requestedDate } : {}),
    ...(hasText(requestedTime) ? { requested_time: requestedTime } : {})
  })
}
